import DP3 from 'elem/compPage/DP3';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import Head from 'next/head';
import CountDown from '@elem/compPage/DP3/components/CountDown';
import { DP3Provider } from 'elem/compPage/DP3/DP3Provider';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import dynamic from 'next/dynamic';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useLang } from '@/i18n';
import { redirectTo404 } from '@/utils';

const whiteLocaleList = ['us', 'ca', 'jp', 'eu', 'de', 'fr', 'it', 'es', 'au', 'cn', 'br', 'mx', 'ph', 'nl'];
const isPrd = process.env.NEXT_PUBLIC_MODY === 'prd'; //是否是生产环境
export default function DP3Page({ SEO, lang, timeLine, debug, status }: any) {
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph', 'nl'].includes(locale);
    const { t } = useLang(IS_EU_SITES || locale === 'cn' ? 'dp3' : 'dp3.teaser');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    const isDebug = debug && Object.values(IPageStatus).includes(debug);

    const initState = {
        pageStatus: status,
        timeLine: timeLine,
    };
    if (isDebug) {
        initState.pageStatus = debug;
    }

    return (
        <PageLayout isNoFixed={true}>
            {locale === 'jp' && (
                <Head>
                    {/* 预加载 LCP 图片 - PC */}
                    <link
                        rel="preload"
                        as="image"
                        href="https://websiteoss.ecoflow.com/figma-uploads/1765783161171-vdyymp-compressed-1765783156793.webp"
                        media="(min-width: 1025px)"
                    />
                    {/* 预加载 LCP 图片 - 移动端 */}
                    <link
                        rel="preload"
                        as="image"
                        href="https://websiteoss.ecoflow.com/figma-uploads/1765783186408-unk5w2-compressed-1765783184487.webp"
                        media="(max-width: 1024px)"
                    />
                </Head>
            )}
            <SEO title={lang.seo_title || t('seo_title')} description={lang.seo_desc || t('seo_desc')} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname={'delta-pro-3-portable-power-station'} />
            <GtmPageLoad />
            <DP3Provider state={initState}>
                {!isDebug && <CountDown />}
                <DP3 />
            </DP3Provider>
        </PageLayout>
    );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    const { debug, _timer } = query;

    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }

    let data = null;
    try {
        data = require(`@/data/dp3/${locale}.js`);
    } catch (err) {
        data = require(`@/data/dp3/us.js`);
        // throw new Error('读取/data/dp3/us.js失败');
    }

    const timeLine = data.timeLine || null; // 代码保存的时间线

    let systemTime = new Date().getTime(); // 系统时间
    if (_timer) {
        // 读取url上的时间进行测试
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }

    // 当前页面阶段
    let pageStatus = IPageStatus.statusA;
    if (debug) {
        // 是否进入调试状态
        pageStatus = debug as any;
    } else if (timeLine) {
        if (systemTime >= timeLine?.statusC?.start) {
            // 系统时间进入 statusC 时间段
            pageStatus = IPageStatus.statusC;
        } else if (systemTime >= timeLine?.statusB?.start) {
            // 系统时间进入 statusB 时间段
            pageStatus = IPageStatus.statusB;
        } else if (systemTime >= timeLine?.statusA?.start) {
            // 系统时间进入 statusA 时间段
            pageStatus = IPageStatus.statusA;
        } else if (isPrd) {
            // 系统时间不在上述时间段,且进入生产环境才跳转404
            return redirectTo404();
        }
    }

    return {
        props: {
            systemTime,
            timeLine: timeLine,
            debug: debug || '',
            pageStatus: pageStatus,
        },
    };
}
